
import { useEffect, useState } from 'react'
import { BriefcaseBusiness, Plus, XIcon } from 'lucide-react'
import Style from './style.module.css'
import LeftSidePopupLayout from '../../../../component/popup/modal-layout'
import AddVendorPopup from '../vendor/add-popup'
import AddPopup from '../list/add-popup'
import AddInvoicePopup from '../invoice/add-popup'
import { useApiCall } from '../../../../component/custom-hooks/api-call'

const FuleInvPopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, dropdowns, tabIndex }) => {
    const [navIndex, setNavIndex] = useState(tabIndex || 0);

    const [allRecords, setAllRecords] = useState([])

    const apiCall = useApiCall();

    const getAllRecords = async() => {
        try {
            let apiRes = await apiCall({method: "get", url: "get-water-tanker-entry-list?status=pending"});
            // console.log("apiRes", apiRes)
            setAllRecords(apiRes?.data)
        } catch (error) {
            console.log("Error", error)
        }
    }

    useEffect(() => {
        getAllRecords()
    } , [])

    const handleNavClick = (index) => {
        setNavIndex(index);
    };

    const navItems = [
        { label: "Water Records", icon: <Plus size="1.2em" /> },
        { label: "Vendors", icon: <BriefcaseBusiness size="1.2em" /> },
        { label: "Invoice", icon: <Plus size="1.2em" /> },
    ];

    return (
        <>
            <div className={Style.modal_body}>
                <LeftSidePopupLayout popupStatus={true} className={`${Style.departmentChangeModal}`}>
                    <div className={Style.modal_header}>
                        <div className={Style.modal_nav}>
                            <ul>
                                {navItems.map((item, i) => {
                                    console.log("object", tabIndex, navIndex, i)

                                    return (
                                        <li
                                            key={i}
                                            className={`${navIndex === i ? Style.active : ""} ${(tabIndex || tabIndex == 0) ? navIndex === i ? "" : Style.disabled : ""}`}
                                            onClick={() => {
                                                if (tabIndex || tabIndex == 0) {
                                                    if (!navIndex === i) {
                                                        handleNavClick(i);
                                                    }
                                                } else {
                                                    handleNavClick(i);
                                                }
                                            }}
                                        >
                                            <div className={Style.icon}>{item.icon}</div>
                                            <span>{item.label}</span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>

                        <div
                            className={Style.close_btn}
                            style={{
                                position: 'absolute',
                                top: '-16px',
                                right: '-16px'
                            }}
                            onClick={() => { onClose() }}
                        ><XIcon size={'1em'} /></div>
                    </div>

                    {
                        navIndex === 0 && (
                            <AddPopup
                                onClose={onClose}
                                onError={onError}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                dropdowns={dropdowns}
                                Style={Style}
                            />
                        )
                    }

                    {
                        navIndex === 1 && (
                            <AddVendorPopup
                                onClose={onClose}
                                onError={onError}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                Style={Style}
                            />
                        )
                    }

                    {
                        navIndex === 2 && (
                            <AddInvoicePopup
                                onClose={onClose}
                                onError={onError}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                dropdowns={dropdowns}
                                Style={Style}
                                records={allRecords}
                            />
                        )
                    }
                </LeftSidePopupLayout>
            </div>
        </>
    )
}

export default FuleInvPopup
